// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"e5e6899b","256":"1d3a2d58","535":"5ae245f8","812":"537c5586","888":"50cdd6e4","922":"e9ebfc8c","991":"6eeab73c"}[chunkId] + ".chunk.js";
};